const partner_slider = () => {
    var partner_swiper = new Swiper(".partners-slider", {
        navigation: {
            nextEl: ".next-partner",
            prevEl: ".prev-partner",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            578: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 60,
            },
        },
    });
}

export default partner_slider;